(function () {
	'use strict';

	a3_pilot_reports.factory('CheckInFactory', CheckInFactory);
    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name CheckInFactory
    * @description 
    *   Get list, Update list & Acknowledge schedule changes
    * @ngInject
    */
	function CheckInFactory(GenericService, $http, apiUrl) {
        /**
         * Initialize the ScheduleChanges
         * @memberof CheckInFactory
         */
        function CheckIn() {
            
        }

        var objType = 'CheckIn';
        var objCallback = CheckIn;

        var response = { success: false, 
                         message: '', 
                         checkInInfo: null
                        };

		var service = {
			setCheckInInfoToStorage : setCheckInInfoToStorage,
			getCheckInInfoFromStorage : getCheckInInfoFromStorage,
            checkIn : checkIn,
            saveCheckInDelay: saveCheckInDelay
		};

		/**
		 * Save check in info
		 * @param {array} checkInInfo 
		 */
        function setCheckInInfoToStorage(checkInInfo) {
            if(checkInInfo == undefined || checkInInfo == null){
                GenericService.removeAll(objType);
            }
            else{
                GenericService.saveOne(checkInInfo, objType, objCallback);
            }
        }

		/**
		 * Get check in info
		 */
         function getCheckInInfoFromStorage(){
            return GenericService.getOne(objType, objCallback);;
		}

    
        /**
         * Check In
         * @returns {promise} response
         */
        function checkIn(confirmed){
            return $http.get(apiUrl + '/CrewCheckIn/CheckIn?confirmed=' + confirmed, { 'Content-Type' : 'application/json' })
            .then(res => updateCheckInCallBack(res))
            .catch(res => checkInFailedCallBack(res));
        }

        /**
         * Update Schedule changes dates
         * @param {object} res 
         * @param {object} objectToAdd 
         * @returns {object} response
         */
        function updateCheckInCallBack(res) {
            response.success = res.data.success;
            if (res.data.success) {
                //update local storage
                setCheckInInfoToStorage(res.data.data);
                response.checkInInfo = res.data.data;
                if(response.checkInInfo && response.checkInInfo.Confirmed && response.checkInInfo.ErrorExplanation === ""){
                    response.message = "Success! Check In Confirmed.";
                }else if(response.checkInInfo && !response.checkInInfo.Confirmed && response.checkInInfo.ErrorExplanation === ""){
                    response.message = "Ready for Check In.";
                }else if(response.checkInInfo){
                    response.message = response.checkInInfo.ErrorExplanation;
                }else{
                    response.message = "You have not pending Check In.";
                }
            }
            else {
                response.message = res.data.errorMessage
            }

            return response;
        }

        /**
        * The callback function upon failure on submit
        * @returns {object} response
        */
        function checkInFailedCallBack(res) {
            
            response.success = false;
            response.message = "Oops! Something went wrong"

            //TODO::Check status=500 error: returns res = {data: {…}, status: 500, config: {…}, statusText: "Internal Server Error", headers: ƒ}
            // res.data.data is null
            if(res.data.data ){
                response.checkInInfo = res.data.data;
            }else{
                //log results
                console.log(res);
            }
            return response;
        }

        /**
         * Save Check In Delay
         * @returns {promise} response
         */
         function saveCheckInDelay(delayMinutes){
            var checkInInfo = getCheckInInfoFromStorage();
            checkInInfo.DelayMinutes = +delayMinutes;
            return $http.post(apiUrl + '/CrewCheckIn/SaveCheckInDelay', checkInInfo, { 'Content-Type': 'application/json' })
            .then(res => updateCheckInDelayCallBack(res))
            .catch(res => checkInFailedCallBack(res));
        }
        function updateCheckInDelayCallBack(res) {
            response.success = res.data.success;
            if (res.data.success) {
                response.message = "Success! Delay message was sent.";
            }
            else {
                response.message = res.data.errorMessage
            }

            return response;
        }
		return service;
	}
})();
